import CarlineGridView from './CarlineGridView'
import carlineGridViewContainer from './carlineGridViewContainer'

export default carlineGridViewContainer(CarlineGridView)
